import React, { useEffect } from "react";
import { Card, Col, Container, Row } from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import ProductListing from "./ProductListing";

const Product = () => {
  const breadcrumbItems = [
    { title: "Prod", link: "" },
    { title: "Product", link: "/prod/product" },
  ];

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb items={breadcrumbItems} />
          <Card className="card_container">
            <ProductListing />
          </Card>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Product;